import shortHeaderStyles from 'styles/css/ShortHeaderStyles.module.scss';
import sharedStyles from 'styles/css/SharedStyles.module.scss';
import Logo from 'styles/images/logo/logo512.png';
import BackIcon from 'styles/images/svg/back.svg';
import { useNavigate } from "react-router-dom";


const ShortHeaderWithBackBtnNameOfGod = (props) => {

	const navigate = useNavigate();

    return (

        <div className={[sharedStyles.flex, sharedStyles['flex-col'], sharedStyles.itemsCenter, sharedStyles['py-[24px]']].join(' ')}>
	        <div className={[shortHeaderStyles['header-logo-back'], sharedStyles['w-full']].join(' ')}>
	            <img onClick={() => navigate(-1)} className={shortHeaderStyles['back-btn']} src={BackIcon} width={18} height={18}  />
	            <img src={Logo} alt="Dr20" className={shortHeaderStyles.logo} />
	            <span className={shortHeaderStyles['hide-like-back-btn']} />
	        </div>
	        <div className={[sharedStyles.flex, sharedStyles['flex-col']].join(' ')}>
	        	<span className={[sharedStyles['text-green'], sharedStyles['font-weight-900'], sharedStyles['mt-[8px]']].join(' ')}>HEALTH IS WEALTH</span>
		        <span className={[sharedStyles['text-green'], sharedStyles['font-[20px]'], sharedStyles['font-weight-900'], sharedStyles['mt-[8px]']].join(' ')}>
		        	بسم الله النور
	        	</span>
	        	<span className={[sharedStyles['text-green'], sharedStyles['font-[20px]'], sharedStyles['font-weight-900'], sharedStyles['text-left']].join(' ')}>
		        	الرحمن الرحیم
	        	</span>
	        </div>
		        
        </div>

    );
}

export default ShortHeaderWithBackBtnNameOfGod;
